import DriverActualsBookingPanel from '@/components/driver_actuals_booking_panel.vue'
import {
  buildBookingDetailsFromSegments,
  panelPositionFromEvent,
} from '@/helpers/driver_actuals_booking_details'

export default {
  components: {
    DriverActualsBookingPanel,
  },

  data() {
    return {
      booking_panel_visible: false,
      booking_panel_details: [],
      booking_panel_style: {},
      booking_panel_hide_timer: null,
      timeline_hover_cell_key: null,
    }
  },

  beforeDestroy() {
    this.clearBookingPanelHideTimer()
    if (this._filterDebounceTimer) {
      clearTimeout(this._filterDebounceTimer)
      this._filterDebounceTimer = null
    }
  },

  methods: {
    bookingDetailVariant() {
      return 'cm'
    },
    bookingDetailResourceType() {
      return 'vehicle'
    },
    clearBookingPanelHideTimer() {
      if (this.booking_panel_hide_timer) {
        clearTimeout(this.booking_panel_hide_timer)
        this.booking_panel_hide_timer = null
      }
    },
    scheduleHideBookingPanel() {
      this.clearBookingPanelHideTimer()
      this.booking_panel_hide_timer = setTimeout(() => {
        this.booking_panel_visible = false
        this.booking_panel_details = []
        this.timeline_hover_cell_key = null
      }, 250)
    },
    scheduleFilterResults() {
      if (this._filterDebounceTimer)
        clearTimeout(this._filterDebounceTimer)
      this._filterDebounceTimer = setTimeout(() => {
        this._filterDebounceTimer = null
        this.filter_results()
      }, 250)
    },
    onTimelineCellHover({ event, segments, cellKey }) {
      this.clearBookingPanelHideTimer()
      if (!segments || !segments.length) {
        this.timeline_hover_cell_key = null
        this.scheduleHideBookingPanel()
        return
      }
      if (cellKey === this.timeline_hover_cell_key)
        return
      this.timeline_hover_cell_key = cellKey
      const datetimeFormat = (this.summary && this.summary.datetime_format) || 'MM/DD/YYYY hh:mm A'
      this.booking_panel_details = buildBookingDetailsFromSegments(
        segments,
        this.bookingDetailVariant(),
        datetimeFormat,
        this.bookingDetailResourceType()
      )
      this.booking_panel_style = panelPositionFromEvent(event)
      this.booking_panel_visible = true
    },
    onTimelineCellLeave() {
      this.timeline_hover_cell_key = null
      this.scheduleHideBookingPanel()
    },
    onBookingPanelEnter() {
      this.clearBookingPanelHideTimer()
    },
    onBookingPanelLeave() {
      this.scheduleHideBookingPanel()
    },
  },
}
